const RETURN_TO_STORAGE_KEY = "clarityos:returnTo";

export function sanitizeReturnTo(value?: string) {
  if (!value) {
    return "/";
  }

  if (value === "/auth34") {
    return "/";
  }

  if (value.startsWith("/auth34/")) {
    return value.replace("/auth34", "");
  }

  if (!value.startsWith("/") || value.startsWith("//")) {
    return "/";
  }

  return value;
}

export function storeReturnTo(value: string) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.sessionStorage.setItem(
      RETURN_TO_STORAGE_KEY,
      sanitizeReturnTo(value),
    );
  } catch {
    return;
  }
}

export function takeStoredReturnTo() {
  if (typeof window === "undefined") {
    return undefined;
  }

  try {
    const value = window.sessionStorage.getItem(RETURN_TO_STORAGE_KEY);

    if (!value) {
      return undefined;
    }

    window.sessionStorage.removeItem(RETURN_TO_STORAGE_KEY);
    return value;
  } catch {
    return undefined;
  }
}

export function getCurrentReturnTo() {
  if (typeof window === "undefined") {
    return "/";
  }

  return sanitizeReturnTo(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
}
